
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useLocalizedPath } from '../utils/localizedPath.js';

const ProtectedRoute = ({ children }) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const { localize } = useLocalizedPath();

  if (authStatus !== 'authenticated') {
    return <Navigate to={localize('/login')} replace />;
  }

  return children;
};

export default ProtectedRoute;
